import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11}
    height={12}
    fill="none"
    viewBox="0 0 11 12"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M.65 3.013h9.45M1.831 3.013H8.92V10.1a.787.787 0 0 1-.788.788H2.62a.787.787 0 0 1-.788-.788zM3.406 3.013v-.394a1.969 1.969 0 0 1 3.938 0v.394M4.194 5.376v3.151M6.556 5.376v3.151"
    />
  </svg>
);
export default SvgStreamlineTrash;
